<section class="modal-window">
  <header>
    <h3><span i18n>Password recovery</span></h3>
  </header>
  <div class="mw-body">
    <form [formGroup]="mail_ctrl" class="full-width">
      <mat-form-field appearance="outline" focused cdkFocusInitial>
        <mat-label><span i18n>Enter user name</span></mat-label>
        <input matInput formControlName="nombre">
        @if (this.mail_ctrl.controls['nombre'].touched && this.mail_ctrl.controls['nombre'].status==='INVALID') {
          <mat-hint>
            <span i18n>Mandatory</span>
          </mat-hint>
        }
      </mat-form-field>
    </form>
    @if (send_error()) {
      <div class="messsage-error" [innerHTML]="error_message()">
    
      </div>
    }
  </div>

  <footer mat-dialog-actions>
  <button mat-flat-button color="warn" (click)="close()">
      <span i18n="@@cancel">Cancel</span></button>
    <button mat-flat-button color='primary'
      [btnLoading]="loading()"
      [disabled]="mail_ctrl.status=='INVALID'"
      (click)="sendRecoveryMail()"
    >Send</button>
    <!-- [mat-dialog-close]="this.mail_ctrl.value" -->
  </footer>

</section>
